import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ElearningComponent } from './elearning/elearning.component';
import { ManageelearningComponent } from './manageelearning/manageelearning.component';
import { ManagepuzzlesComponent } from './managepuzzles/managepuzzles.component';

import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageElearningModule} from 'ph-bhp-feature-packages/ph-bhp-feature-package-elearning/public_api';
import { StartpuzzleComponent } from './startpuzzle/startpuzzle.component';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';

// common libraries


@NgModule({
  declarations: [
    ElearningComponent,
    ManageelearningComponent,
    ManagepuzzlesComponent,
    StartpuzzleComponent
  ],
  imports: [
    CommonModule,
    PHBHPLocalizePackageModule,
    PHBHPLayoutPackageModule,
    PHBHPFeaturePackageElearningModule,
    PhBhpUiModule
  ]
})
export class ElearningModule { }
